

export const getDefaultName = (prefix = 'New Role') => {
    const date = new Date();
    const dateStr = date.toLocaleDateString('en-US');
    const timeStr = date.toLocaleTimeString('en-US', {timeStyle: 'short'}).toLowerCase().replace(/\s/g, '');
    return `${prefix.slice(0, 50)} - ${dateStr} ${timeStr}`;
};
